module.exports = __webpack_public_path__ + "static/media/18.64a0a068.jpg";